export default {
  name: 'custom-rules',
  translationKey: 'custom-rules-module',
  routePrefix: 'custom-rules',
  routeNamePrefix: 'custom-rules',
  directRoutesAvailable: false,
}
